import React from 'react';

function isClassComponent(component) {
  return !!(typeof component === 'function' && !!component.prototype.isReactComponent);
}
function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('return React.createElement');
}
function isReactComponent(component) {
  return !!(isClassComponent(component) || isFunctionComponent(component));
}
function isElement(element) {
  return /*#__PURE__*/React.isValidElement(element);
}
function isDOMTypeElement(element) {
  return isElement(element) && typeof element.type === 'string';
}
function isCompositeTypeElement(element) {
  return isElement(element) && typeof element.type === 'function';
}

export { isClassComponent, isCompositeTypeElement, isDOMTypeElement, isElement, isFunctionComponent, isReactComponent };
//# sourceMappingURL=reactTypesUtility.js.map
